<template>
  <v-container>
    <v-row v-if="showAnimation" justify="center" align="center">
      <div style="height: 300px;">
        <loading-animation @loopComplete="loadAnimationComplete"></loading-animation>
      </div>
    </v-row>
    <v-row v-show="!showAnimation" justify="center" align="center">
      <v-col cols="12">
        <span class="ml-n2 mt-3" style="font-family: Roboto; font-style: normal; font-weight: normal; font-size: 14px; color: transparent;">
          <br/>
        </span>
      </v-col>
      <v-col cols="12" style="overflow-x: auto" class="mt-n6">
        <div id="chart-meteorogical-daily" style="min-width: 1100px"></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Highcharts from "highcharts";
import Accessibility from 'highcharts/modules/accessibility';
import moment from "moment";
import LoadingAnimation from "../LoadingAnimation";
Accessibility(Highcharts);
export default {
  components: {LoadingAnimation},
  props:['location'],
  name: "DiaryMeteorologicalChart",
  data: () => ({
    loading: false,
    showAnimation: false,
    arrayPrecDaily: [],
    arrayTempMin: [],
    arrayTempMax: [],
    chartRendered: undefined,
  }),
  watch: {
    location(){
      if(this.location){
        this.initialize()
      }
    }
  },
  mounted() {
    this.initialize()
  },
  methods: {
    loadAnimationComplete(){
      this.showAnimation = this.loading;
    },
    dateToUTC(x) {
      let utc = moment(x, "YYYY-MM-DD").locale("pt-br").format("YYYY-MM-DD");
      x = moment.utc(utc).locale("pt-br").valueOf();
      return x;
    },
    mapIcon(id) {
      let icon, isDay = true
      if (id == 4) {
        icon = "icon-infohidro-wi-cloud";
      } else if (id == 6) {
        icon = "icon-infohidro-wi-rain";
      } else if(id == 7){
        icon = "icon-infohidro-wi-thunderstorm";
      } else if (id == 8) {
        icon = "icon-infohidro-wi-snowflake-cold";
      } else if (id == 9) {
        icon = "icon-infohidro-wi-snow";
      } else if (id == 11) {
        icon = "icon-infohidro-wi-fog";
      } else if (id == 999) {
        icon = " ";
      }
      if (isDay == true) {
        if (id == 1) {
          icon = "icon-infohidro-wi-day-sunny";
        } else if (id == 2) {
          icon = "icon-infohidro-wi-day-sunny-overcast";
        } else if (id == 3) {
          icon = "icon-infohidro-wi-day-cloudy";
        } else if (id == 5) {
          icon = "icon-infohidro-wi-day-rain";
        } else if (id == 10) {
          icon = "icon-infohidro-wi-day-thunderstorm";
        } else if (id == 999) {
          icon = " ";
        }
      } else if (isDay == false) {
        if (id == 1) {
          icon = "icon-infohidro-wi-night-clear";
        } else if (id == 2) {
          icon = "icon-infohidro-wi-night-alt-partly-cloudy";
        } else if (id == 3) {
          icon = "icon-infohidro-wi-night-alt-cloudy";
        } else if (id == 5) {
          icon = "icon-infohidro-wi-night-alt-rain";
        } else if (id == 10) {
          icon = "icon-infohidro-wi-night-thunderstorm";
        } else if (id == 999) {
          icon = " ";
        }
      }
      return icon;
    },
    mapText(id) {
      let text;
      if (id == 4) {
        text = "Nublado";
      } else if (id == 6) {
        text = "Chuva";
      } else if (id == 7) {
        text = "Tempestade";
      } else if (id == 8) {
        text = "Geada";
      } else if (id == 9) {
        text = "Neve";
      } else if (id == 11) {
        text = "Neblina";
      } else if (id == 1) {
        text = "Céu Claro";
      } else if (id == 2) {
        text = "Poucas Nuvens";
      } else if (id == 3) {
        text = "Muitas Nuvens";
      } else if (id == 5) {
        text = "Parcialmente nublado com pancadas de chuva";
      } else if (id == 10) {
        text = "Parcialmente Nublado com chuvas e trovoadas";
      } else {
        text = " ";
      }
      return text;
    },
    async initialize(){
      this.loading = true;
      this.showAnimation = true;
      this.arrayPrecDaily = [];
      this.arrayTempMax = [];
      this.arrayTempMin = [];
      await this.$store.dispatch('loadMeteorologicalForecast', {
        type: 'daily',
        source: '22',
        location_id: this.location.locationid
      })
      let daily = await this.$store.getters.meteorologicalForecast
      daily = daily[0].value
      let iconsDaily = {}
      for(let item in daily) {
        let itemDaily = {
          icon: this.mapIcon(daily[item].summaryId),
          text: this.mapText(daily[item].summaryId),
          id: daily[item].summaryId,
          date: daily[item].date,
        }
        let dateF = this.dateToUTC(daily[item].date)
        iconsDaily[dateF] = itemDaily
      }
      for (let index in daily) {
        this.arrayPrecDaily.push([
          this.dateToUTC(daily[index].date),
          daily[index].precIntensity,
        ]);
        this.arrayTempMax.push([
          this.dateToUTC(daily[index].date),
          daily[index].tempMax,
        ]);
        this.arrayTempMin.push([
          this.dateToUTC(daily[index].date),
          daily[index].tempMin,
        ]);
      }
      this.chartRendered = Highcharts.chart("chart-meteorogical-daily", {
        chart: {
          backgroundColor: this.$vuetify.theme.themes.dark.primary.darken1,
        },
        title: { text: null },
        subtitle: { text: null },
        credits: {
          enabled: false,
          href: "http://www.simepar.br/",
          text: "by: SIMEPAR",
          style: { color: "#FFFFFF" },
        },
        legend: {
          enabled: false,
          itemStyle: { color: "#FFFFFF" },
          itemHoverStyle: { color: "#979797" },
        },
        xAxis: {
          opposite: true,
          lineColor: 'transparent',
          gridLineColor: 'transparent',
          minorGridLineColor: 'transparent',
          tickColor: 'transparent',
          visible: true,
          labels: {
            useHTML: true,
            formatter: function() {
              if(iconsDaily[this.value].icon !== ' ' && iconsDaily[this.value].text !== ' '){
                return '<span style="color: #FFFFFF; font-size: 14px">'+ moment(iconsDaily[this.value].date,'YYYY-MM-DD').tz("America/Sao_Paulo").format('DD/MM') +'</span>'
                  +'<br>'+
                  '<span style="color: #FFFFFF; text-transform: capitalize; font-size: 16px; font-weight: bold;">'+ moment(iconsDaily[this.value].date,'YYYY-MM-DD').tz("America/Sao_Paulo").locale('pt-br').format('ddd') +'</span>'
                  +'<br>'+
                  '<i class="'+ iconsDaily[this.value].icon +'" style="color: #FFFFFF; font-size: 40px"></i>';
              } else {
                return '<span style="color: #FFFFFF; font-size: 14px">'+ moment(iconsDaily[this.value].date,'YYYY-MM-DD').tz("America/Sao_Paulo").format('DD/MM') +'</span>'
                  +'<br>'+
                  '<strong style="color: #FFFFFF; text-transform: capitalize; font-size: 16px; font-weight: bold;">'+ moment(iconsDaily[this.value].date,'YYYY-MM-DD').tz("America/Sao_Paulo").locale('pt-br').format('ddd') +'</strong>'
                  +'<br>'+
                  '<i class="icon-infohidro-wi-day-cloudy" style="color: transparent; font-size: 40px"></i>'
              }
            }
          },
          type: "datetime",
          /*            labels: {
                        format: "{value: %d/%m <br> %a}",
                        style: { color: "#FFFFFF" },
                      },*/
          title: {
            enabled: false,
            style: { color: "#FFFFFF" },
          },
        },
        yAxis: [
          {
            visible: false,
            reversed: false,
            opposite: false,
            min: 0,
            height: "70%",
          },
          {
            visible: false,
            reversed: true,
            opposite: true,
            min: 0,
            top: "60%",
            height: "30%",
            offset: 0,
          },
        ],
        plotOptions: {
          series: {
            marker: { enabled: false },
          },
        },
        colors: ["#0071B0", "#ff5700", "#FF9F00"],
        tooltip: {
          useHTML: true,
          backgroundColor: '#212a35',
          borderWidth: 0,
          formatter: function () {
            return this.points.reduce(function (s, point) {
              return s +'<div style="background-color: #212a35">'+ '<br/>' + '<b style="color:' + point.series.color + '">' +point.series.name + ': ' + '</b>'+
                '<b style="color: #FFFFFF">' + (point.y).toFixed(point.series.tooltipOptions.valueDecimals) + point.series.tooltipOptions.valueSuffix +'</b>';
            }, '<b style="text-transform: capitalize; color: #FFFFFF">' + moment.utc(this.x).locale('pt-br').format('dddd, DD/MM/YYYY') + '</b>' + '<br/>' + '<b style="color: #FFFFFF">' + iconsDaily[this.x].text + '</b>' + '<br/>' + '</div>');
          },
          shared: true,
          crosshairs: true,
        },
        series: [
          {
            name: "Precipitação",
            type: "column",
            yAxis: 1,
            data: this.arrayPrecDaily,
            tooltip: {
              valueDecimals: 1,
              valueSuffix: "mm",
            },
            dataLabels: {
              enabled: true,
              //format: '{y}mm',
              formatter: function () {
                return this.y.toFixed(1) + "mm";
              },
              verticalAlign: "top",
              style: { color: "#FFFFFF" },
            },
          },
          {
            name: "Temperatura Máxima",
            type: "line",
            yAxis: 0,
            data: this.arrayTempMax,
            tooltip: {
              valueDecimals: 0,
              valueSuffix: "°C",
            },
            dataLabels: {
              enabled: true,
              //format: '{y}˚C',
              formatter: function () {
                return this.y.toFixed(0) + "˚C";
              },
              verticalAlign: "bottom",
              style: { color: "#FFFFFF" },
            },
          },
          {
            name: "Temperatura Mínima",
            type: "line",
            yAxis: 0,
            data: this.arrayTempMin,
            tooltip: {
              valueDecimals: 0,
              valueSuffix: "°C",
            },
            dataLabels: {
              enabled: true,
              //format: '{y}˚C',
              formatter: function () {
                return this.y.toFixed(0) + "˚C";
              },
              verticalAlign: "top",
              style: { color: "#FFFFFF" },
            },
          },
        ],
        caption:{
          text: 'Gráfico de dados meteorológicos de 15 dias',
          style: { color: '#FFFFFF'},
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                plotOptions: {
                  series: {
                    marker: {
                      radius: 2.5,
                    },
                  },
                },
              },
            },
          ],
        },
        exporting: {
          enabled: false,
          filename: this.location.text + ' - ' + '15 dias',
          chartOptions: {
            title: {
              text: 'Dados meteorológicos para 15 dias',
              style: {
                color: '#FFFFFF'
              }
            },
            subtitle: {
              text: this.location.text,
              style: {
                color: '#FFFFFF'
              }
            },
          }
        },
      });
      this.$emit('chartRenderComplete', this.chartRendered);
      this.loading = false;
    },
  },
}
</script>

<style scoped>

</style>
